/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetTenantRestrictionsByTenantIDOptions,
  GetTenantRestrictionsByTenantIDStatus200,
  GetTenantRestrictionsByTenantIDStatus404,
  GetTenantRestrictionsByTenantIDStatus500,
} from '../types/GetTenantRestrictionsByTenantID'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getTenantRestrictionsByTenantID } from '../clients/getTenantRestrictionsByTenantID'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getTenantRestrictionsByTenantIDQueryKey = ({
  path,
}: Omit<GetTenantRestrictionsByTenantIDOptions, 'headers'>) =>
  [{ url: '/v1/tenants/:tenant_id/restrictions', params: path }] as const

type GetTenantRestrictionsByTenantIDQueryKey = ReturnType<
  typeof getTenantRestrictionsByTenantIDQueryKey
>

export function getTenantRestrictionsByTenantIDQueryOptions(
  { path }: GetTenantRestrictionsByTenantIDOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getTenantRestrictionsByTenantIDQueryKey({ path })
  return queryOptions<
    GetTenantRestrictionsByTenantIDStatus200,
    ResponseErrorConfig<
      GetTenantRestrictionsByTenantIDStatus404 | GetTenantRestrictionsByTenantIDStatus500
    >,
    GetTenantRestrictionsByTenantIDStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getTenantRestrictionsByTenantID({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get tenant restrictions by tenant ID
 * {@link /v1/tenants/:tenant_id/restrictions}
 */
export function useGetTenantRestrictionsByTenantID<
  TData = GetTenantRestrictionsByTenantIDStatus200,
  TQueryData = GetTenantRestrictionsByTenantIDStatus200,
  TQueryKey extends QueryKey = GetTenantRestrictionsByTenantIDQueryKey,
>(
  {
    path,
  }: {
    path:
      | GetTenantRestrictionsByTenantIDOptions['path']
      | (() => GetTenantRestrictionsByTenantIDOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetTenantRestrictionsByTenantIDStatus200,
        ResponseErrorConfig<
          GetTenantRestrictionsByTenantIDStatus404 | GetTenantRestrictionsByTenantIDStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey =
    resolvedOptions?.queryKey ?? getTenantRestrictionsByTenantIDQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getTenantRestrictionsByTenantIDQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      GetTenantRestrictionsByTenantIDStatus404 | GetTenantRestrictionsByTenantIDStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
